// extracted by mini-css-extract-plugin
module.exports = {"topBarsWrap":"topBarsWrap___35lMN","rightPart":"rightPart___3cNTm","downloadBtn":"downloadBtn___28Dtd"};